const translations = {
    batteries: 'Batteries',
    batteriesAreRequired: 'At least one battery is required'
};

export default translations;
